import { memo, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { resolvePersistedChartKind, PERSISTED_CHART_KIND } from '../lib/statisticsPersistedCharts';
import resolveDashboardChartModalHeight from '../lib/resolveDashboardChartModalHeight';
import DashboardChartMeta from './DashboardChartMeta';
import DashboardChartRefreshModeBadge from './DashboardChartRefreshModeBadge';
import DashboardChartView from './DashboardChartView';

const DashboardChartExpandModal = ({ show, onHide, snapshot, chartBundle, isManager = false }) => {
	const [showPointLabels, setShowPointLabels] = useState(snapshot?.ui?.showPointLabels ?? true);
	const isCompositionChart = resolvePersistedChartKind(snapshot) === PERSISTED_CHART_KIND.COMPOSITION;

	useEffect(() => {
		if (show) {
			setShowPointLabels(snapshot?.ui?.showPointLabels ?? true);
		}
	}, [show, snapshot?.ui?.showPointLabels]);

	const notifyLayoutChange = useCallback(() => {
		requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
	}, []);

	const chartHeight = resolveDashboardChartModalHeight(snapshot, chartBundle, 'full');

	return (
		<Modal
			show={show}
			onHide={onHide}
			size='xl'
			centered
			className='statistics-persisted-chart-modal'
			contentClassName='statistics-persisted-chart-modal__content'
			onEntered={notifyLayoutChange}
			onExited={notifyLayoutChange}
		>
			<Modal.Header closeButton className='statistics-persisted-chart-modal__header'>
				<div className='statistics-persisted-chart-modal__header-main'>
					<div className='statistics-persisted-chart-modal__title-row'>
						<Modal.Title className='statistics-persisted-chart-modal__title mb-0'>{snapshot?.title}</Modal.Title>
						<DashboardChartRefreshModeBadge snapshot={snapshot} />
					</div>
					<DashboardChartMeta snapshot={snapshot} show={show} isManager={isManager} />
				</div>
			</Modal.Header>
			<Modal.Body className='statistics-persisted-chart-modal__body'>
				{!isCompositionChart ? (
					<div className='statistics-persisted-chart-modal__toolbar'>
						<label className='statistics-trend-chart__label-toggle mb-0'>
							<input type='checkbox' checked={showPointLabels} onChange={(event) => setShowPointLabels(event.target.checked)} />
							<span>显示数值</span>
						</label>
					</div>
				) : null}
				<div className='statistics-persisted-chart-modal__chart'>
					<DashboardChartView
						snapshot={snapshot}
						chartBundle={chartBundle}
						height={chartHeight}
						showPointLabels={showPointLabels}
					/>
				</div>
			</Modal.Body>
		</Modal>
	);
};

DashboardChartExpandModal.propTypes = {
	show: PropTypes.bool.isRequired,
	onHide: PropTypes.func.isRequired,
	snapshot: PropTypes.object,
	chartBundle: PropTypes.object,
	isManager: PropTypes.bool,
};

export default memo(DashboardChartExpandModal);
